import React, { useEffect, useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, TextField, Typography } from '@mui/material';
import { productoDetalle } from '../../utils/types/productoDetalle';
import { cmps } from '../../utils/constants/constantes';
import ProductoTiendaTable from './ProductoTiendaTable';
import { useGestionarCodProdTienda } from '../hooks/useGestionarCodProdTienda';
import { ConfirmDialog, SelectBase, SelectPlus, toast } from 'lib.front/dist';
import { useDispatch } from 'react-redux';
import { loadingModal } from 'src/redux-app';
import { useGestionarProductoDetalle } from '../hooks/useGestionarProductoDetalle';

interface InfoDialogProps {
    open: boolean;
    onClose: () => void;
    productoDetalle: productoDetalle | null;
    productostienda: any[];
    loadDataTable: () => void
}

export const EditProductVerDialog: React.FC<InfoDialogProps> = ({
    open,
    onClose,
    productoDetalle,
    productostienda,
    loadDataTable
}) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [isChange, setIsChange] = useState(false);
    const [urlInstalador, setUrlInstalador] = useState('');
    const [selectedProdTienda, setSelectedProdTienda] = useState(null);
    const [listaCodTienda, setListaCodTienda] = useState<any[]>([]);
    const { addCodProductoTienda, deleteCodProdTienda, getCodProdTienda } = useGestionarCodProdTienda();
    const { updateProductoDetalle } = useGestionarProductoDetalle();

    const fetchCodProdTienda = async () => {
        setIsLoading(true);
        if (productoDetalle) {
            const result = await getCodProdTienda({
                idProdVerPres: productoDetalle.idProdVerPres,
                shopCodProd: null
            })

            if (result) {
                setListaCodTienda(result);
                setIsChange(true);
            }
        };
        setIsLoading(false);
    };

    const fetchAddCodProdTienda = async () => {
        setIsLoading(true);
        if (productoDetalle && selectedProdTienda) {
            const result = await addCodProductoTienda({
                idProdVerPres: productoDetalle.idProdVerPres,
                shopCodProd: selectedProdTienda
            })
            if (result) fetchCodProdTienda();
        };
        setIsLoading(false);
    };

    const fetchDeleteCodProdTienda = async (shopCodProd: string) => {
        setIsLoading(true);
        if (productoDetalle) {
            const result = await deleteCodProdTienda({
                idProdVerPres: productoDetalle.idProdVerPres,
                shopCodProd: shopCodProd
            })
            if (result) fetchCodProdTienda();
        };
        setIsLoading(false);
    };

    const fetchUpdateProductoDetalle = async () => {
        setIsLoading(true);
        if (productoDetalle) {
            const result = await updateProductoDetalle({
                codigoProducto: productoDetalle.codigoProducto,
                codigoVersion: productoDetalle.codigoVersion,
                codigoPresentacion: productoDetalle.codigoPresentacion,
                urlInstalador: urlInstalador
            })
            if (result) {
                toast.showSucces('El URL del instalador se actualizó exitosamente');
                setIsChange(true);
            }
        };
        setIsLoading(false);
    };

    function agregarCodProducto() {
        fetchAddCodProdTienda();
        setSelectedProdTienda(null);
    };

    function close() {
        if (isChange) {
            loadDataTable();
            setIsChange(false);
        }
        setUrlInstalador('');
        onClose();
    }

    //Modal de espera
    function openWaitModal(load: boolean) {
        dispatch(loadingModal(load));
    }

    useEffect(() => {
        if (productoDetalle?.shopCodProds) {
            setListaCodTienda(productoDetalle?.shopCodProds);
        }
    }, [productoDetalle?.shopCodProds])

    useEffect(() => {
        if (productoDetalle?.urlInstalador) {
            setUrlInstalador(productoDetalle.urlInstalador);
        }
    }, [productoDetalle]);

    useEffect(() => {
        openWaitModal(isLoading);
    }, [isLoading]);

    return (
        <>
            <Dialog open={open} onClose={close} fullWidth maxWidth="lg">
                <DialogTitle color="primary" fontSize={20} sx={{ p: '24px 24px 0px 24px' }}>
                    Editar Producto
                </DialogTitle>
                <DialogContent>
                    {productoDetalle &&
                        <Grid container spacing={1}>
                            <Grid container item xs={12} spacing={1}>
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        name={cmps.PRODUCTOS}
                                        label="Producto"
                                        variant="outlined"
                                        margin="dense"
                                        value={productoDetalle.producto}
                                        disabled={true}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        name={cmps.VERSION}
                                        label="Versión"
                                        variant="outlined"
                                        margin="dense"
                                        value={productoDetalle.version}
                                        disabled={true}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        name={cmps.PRESENTACION}
                                        label="Presentación"
                                        variant="outlined"
                                        margin="dense"
                                        value={productoDetalle.presentacion}
                                        disabled={true}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} md={8}>
                                    <TextField
                                        name={cmps.URL}
                                        label="URL Instalador"
                                        variant="outlined"
                                        margin="dense"
                                        value={urlInstalador}
                                        fullWidth
                                        onChange={(e) => setUrlInstalador(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4} alignContent='center'>
                                    <Button variant="contained" color="primary" onClick={fetchUpdateProductoDetalle} > Guardar Link </Button>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider />
                            </Grid>
                            <Grid container item xs={12} spacing={1}>
                                <Grid item xs={12}>
                                    <Typography variant='h6'>Productos Asociados en Tienda</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <SelectBase
                                        //@ts-ignore
                                        name="codProductoTienda"
                                        label="Producto Tienda"
                                        variant="outlined"
                                        margin="dense"
                                        onChange={(selectedOption: any | null) =>
                                            setSelectedProdTienda(selectedOption?.codigoBarra)
                                        }
                                        options={productostienda}
                                        getOptionLabel={(e: any) => `${e.codigoBarra} - ${e.denominacion}`}
                                        getOptionValue={(e: any) => e.codigoBarra}
                                        fullWidth
                                        isClearable
                                    />
                                </Grid>
                                <Grid item xs={6} alignContent='center'>
                                    <Button variant="contained" color="primary" onClick={agregarCodProducto} > Agregar Producto </Button>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <ProductoTiendaTable data={listaCodTienda} listaProductos={productostienda} handleEliminar={fetchDeleteCodProdTienda} />
                            </Grid>
                        </Grid>
                    }
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="primary" onClick={close} >Cerrar</Button>
                </DialogActions>
            </Dialog>

        </>
    )
}